module.exports = "<app-education-desc *ngFor=\"let description of edu.controls; let i=index\" [index]=\"i\" [description]=\"description\" (removed)=\"edu.removeAt($event)\"\n  (notifyedudesc)='onNotify($event)'>\n</app-education-desc>\n<h6><span *ngIf=\"exceed\" class=\"exceed_warning\">Careful, your resume might exceed a page!</span></h6>\n\n<button type=\"button\" class=\"btn btn-link\" (click)=\"addItemy()\">Add more bullets</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/education-form/edu-detail/education/education.component.html
// module id = ./src/app/main/content/education-form/edu-detail/education/education.component.html
// module chunks = main